<tt-card *ngIf="!!get" style="display: block; max-width: 60rem">
    <tt-button-goto ttText="purchhead_print" ttGoto="selectreport" [ttGotoParms]="{ webpage_name: 'purchhead', argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"></tt-button-goto>
    <tt-button-goto ttText="purchhead_email" (ttClick)="openEmailCreateDialog($event)"></tt-button-goto>
    <!-- <tt-button-goto ttText="purchhead_email" ttGoto="emailcreate" [ttGotoParms]="{ webpage: 'purchhead', argtype: 'purch_internal_no', argvalue: get.purch_internal_no }" (ttClick)="openEmailCreateDialog()"></tt-button-goto> -->
    <tt-button-goto ttText="purchhead_documents" [ttBadge]="get.nbr_of_documents" ttGoto="documents" [ttGotoParms]="{ argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"></tt-button-goto>
    <tt-button-goto
        ttText="purchhead_batchdeliveries"
        [ttBadge]="get.nbr_of_batchdeliveries"
        ttGoto="batchdeliveries"
        [ttGotoParms]="{ argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        ttText="purchhead_deviations"
        [ttBadge]="get.nbr_of_deviations"
        ttGoto="deviations"
        [ttGotoParms]="{ argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_stocktransallocation === '1'"
        ttText="purchhead_allocations"
        ttGoto="stocktransallocations"
        [ttGotoParms]="{ argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"
    ></tt-button-goto>
    <tt-button-goto
        *ngIf="get.show_tracesearch === '1'"
        ttText="purchhead_tracesearch"
        ttGoto="tracesearch"
        [ttGotoParms]="{ argtype: 'purch_internal_no', argvalue: get.purch_internal_no }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="get.purch_request_no > '0'" ttText="purchhead_purchrequestcreate" ttGoto="purchrequestcreate" [ttGotoParms]="{ purch_internal_no: get.purch_internal_no }"></tt-button-goto>
    <tt-button
        *ngIf="get.show_convert_to_purchorder === '1'"
        ttText="purchhead_convert_to_purchorder"
        ttIcon="fas fa-sync-alt"
        (ttClick)="convertToPurchOrder()"
        [ttLoading]="convertingToPurchOrder"
    ></tt-button>
    <tt-button *ngIf="get.show_purchhead_delete === '1'" ttText="purchhead_delete" ttType="danger" ttIcon="fas fa-trash-alt" (ttClick)="deletePurchase()" [ttLoading]="deletingPurchase"></tt-button>
    <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="purchhead" (ttClick)="openSettings($event)"></tt-button-settings>
</tt-card>
